import { ActivityCapabilitiesType, ActivityTask, ActivityTaskType, TaskStatus } from './../../model/TaskStatus';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription, of } from 'rxjs';
import { DiscoveredProduct, ProductComponent, ProductExt, ProductInstance, ProductInstanceRow } from 'src/app/model/Product';
import { DataService } from 'src/app/service/data.service';
import { EventService } from 'src/app/service/event.service';
import { SoftwareInventoryService } from 'src/app/service/software-inventory.service';
import { ActionMenuEvent, ActionMenuIcon, ActionMenuItem } from '../controls/actionmenu/action-menu.component';
import { ColumnSort, ColumnType, DataTableColumn, DataTableRow } from '../controls/datatable/datatable.component';
import { tap, finalize, catchError } from 'rxjs/operators';
import { ProductDataType, ProductsComponent, ProductTreeType } from '../products/products.component';
import { AuthenticationService } from 'src/app/service/authentication.service';
import { Events, WebsocketService } from 'src/app/service/websocket.service';
import { Modal } from '../controls/modal/modal.service';
import { ActivityService } from 'src/app/service/activity.service';
import { Agent } from 'src/app/model/Agent';
import { InstanceDetailsComponent } from '../dialogs/instance-details/instance-details.component';
import { ProductResyncComponent } from '../dialogs/product-resync/product-resync.component';
import { ModalMessageComponent } from '../controls/modal-message/modal-message.component';
import { Tab, TabColor } from '../controls/tabs/tabs.component';
import { Utils } from 'src/app/utils';
import { SolutionService } from 'src/app/service/solution.service';

enum ResyncState {INIT, IN_PROGRESS, COMPLETE_SUCCESS, COMPLETE_ERROR}

@Component({
    selector: 'app-product-component-resync',
    templateUrl: './product-component-resync.component.html',
    styleUrls: ['./product-component-resync.component.css'],
    standalone: false
})
export class ProductComponentResyncComponent extends ProductsComponent implements OnInit {
  TabColor = TabColor;
  instancesTab = new Tab('instances-tab', $localize`Instances`, undefined, false);
  tabs: Tab[] = [this.instancesTab];
  activeComponent:ProductComponent;
  activeProductInstances:Record<string, ProductInstance[]>;
  productId:number;
  platform:string;
  activeProduct:ProductExt;
  title:string;
  setupid:string;
  currEnvId:number;
  isQuickAnalysisRequired = false;
  isMasterSystemSelected = true;
  isReload:boolean = false;
  isMasterSystemOnline:boolean = true;
  isSupportHotfix = false;
  state: ResyncState = ResyncState.INIT;
  ResyncState = ResyncState;
  resyncRequestMap = new Object();
  discoveredProductGroup : DiscoveredProduct[];
  selectedInstancesFromPreviousPage:ProductInstanceRow[] = [];  
  
  //datatable
  componentTableCols: DataTableColumn[] =[];
  componentTableRows: DataTableRow[] = [];
  selectedInstanceRows:DataTableRow[] = [];

  constructor(protected eventService: EventService,
              protected authService:AuthenticationService,
              protected siService:SoftwareInventoryService,
              protected dataService:DataService,
              protected wsService: WebsocketService,
              protected router: Router,
              protected modal: Modal,
              protected activityService: ActivityService,
              private route: ActivatedRoute,
              protected solutionService: SolutionService) {
    super(eventService, authService, siService, dataService, wsService, router, modal, activityService, solutionService);
    //if instances were passed in
    if(this.router.currentNavigation() &&
        this.router.currentNavigation().extras && 
        this.router.currentNavigation().extras.state && 
        this.router.currentNavigation().extras.state.instances){
      this.selectedInstancesFromPreviousPage = this.router.currentNavigation().extras.state.instances;
    }else{
      this.selectedInstancesFromPreviousPage = undefined;
    }
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.productId = +params['productId'];
      this.setupid = params['setupid'];
    });

    this.dataSubscription = this.dataService.getData().subscribe((data:any) => {
      if(data && data.type == ProductDataType.AgentManifest){
        this.isAgentManifestUpdating = data.isAgentManifestUpdating;
      } else if(data && data.type == ProductDataType.QuickAnalysis){
        this.solutionInfo = data.solutionInfo;
        this.isManifestUpdating = this.solutionInfo.manifestStatus.isUpdating;
        this.isReload = this.isReload || this.currEnvId != this.solutionInfo.currentEnvironment.id;
        this.platform = undefined;
        this.isMasterSystemOnline = true;
        this.discoveredProductGroup = data.discoveredProductGroup;

        //get platform
        for(let i =0; i < this.discoveredProductGroup.length; i++) {
          let foundProd:ProductExt[] = (this.discoveredProductGroup[i].products.filter((prod:ProductExt) => {
            return prod.id == this.productId;
          }))
          if(foundProd.length > 0){
            this.platform = foundProd[0].platform;
            this.isSupportHotfix = foundProd[0].supportHotfix;

            if(this.isSupportHotfix){
              this.isQuickAnalysisRequired = !foundProd[0].isQuickAnalysisValid;
              this.isMasterSystemOnline = foundProd[0].isMasterSystemOnline;
              this.componentTableCols = Array<DataTableColumn>(
                new DataTableColumn("system", $localize`System`, ColumnType.STRING, true, "28.5", ColumnSort.DESC),
                new DataTableColumn("installPath", $localize`Install path`, ColumnType.STRING, false, "26.5"),
                new DataTableColumn("version", $localize`Version`, ColumnType.STRING, false, "10"),
                new DataTableColumn("platform", $localize`Platform`, ColumnType.STRING, false, "17"),
                new DataTableColumn("agentStatus", $localize`Agent status`, ColumnType.STATUSEXT, false, "18")
              );
            }
          }
        };

        if(this.platform && this.isReload && this.isSupportHotfix){
          this.currEnvId = this.solutionInfo.currentEnvironment.id;
          this.componentTableRows = [];
          this.initView();          
        }else{
          this.router.navigate(['..'], { relativeTo: this.route });
        }
      }
    });

    this.eventMessageSubscription = this.eventService.eventMessage$.subscribe(msg => {
      if(msg.eventType == Events.CSResync){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          let resyncRequest = JSON.parse(msg.body.msg);
          this.resyncRequestMap[resyncRequest.macAddress] = resyncRequest;
          if(this.isResyncComplete()){
            if(this.getNumSuccessCompletedResyncInstances() == this.selectedInstanceRows.length){
              this.state =  ResyncState.COMPLETE_SUCCESS;
            }else{
              this.state =  ResyncState.COMPLETE_ERROR;
            }
            this.selectedInstanceRows = [];
            this.dataService.sendData({type: ProductDataType.Reload});
          }else{
            this.state =  ResyncState.IN_PROGRESS;
          }
        }
      } else if (msg.eventType == Events.ManifestUpdateStarted) {
        this.isManifestUpdating = true;
      } else if (msg.eventType == Events.ManifestUpdateComplete) {
        this.reloadAfterManifestUpdate();
      } else if (msg.eventType == Events.AgentManifestComplete) {
        this.isAgentManifestUpdating = false;
      } else if(msg.eventType == Events.ActivityCapabilities){
        if(this.isPendingTransaction(msg.headers.transactionId, true)){
          this.activityCapabilities = JSON.parse(msg.body.msg);
          if(this.activityCapabilities.activityType == ActivityCapabilitiesType.ENABLE_PRODUCT){
            this.activityCapabilities.tasks.forEach((task:ActivityTask) => {
              if(task.type == ActivityTaskType.VALIDATE_HOST){
                task.completed = true;
                task.success = true;
                task.isCurrentTask = false;
              }else if(task.type == ActivityTaskType.VALIDATE_COMMUNICATIONS){
                task.completed = true;
                task.success = true;
                task.isCurrentTask = true;
              }else{
                task.isCurrentTask = false;
              }
            });
            this.isReload = true;
            this.analyzeMasterSystem(this.solutionInfo, this.activityCapabilities, this.activeProduct);
          }
        }
      }
    });
  }

  initView():void {
    this.isLoading = true;

    this.siService.getProductDetail(this.currEnvId, this.platform, this.productId).pipe(
      tap(resp => {
        this.activeProduct = resp.body;

        let foundComponents = this.activeProduct.components.filter((comp:ProductComponent) => {return comp.setupid === this.setupid});

        if(foundComponents.length > 0){
          this.activeComponent = foundComponents[0];
          this.activeProductInstances = this.activeProduct.instances;
          this.componentTableRows = [];
          this.selectedInstanceRows = [];
          this.title = $localize`${this.activeProduct.name} ${this.activeProduct.version} Component`;
          this.dataService.sendData({type: ProductDataType.Title, title: this.title});
          this.dataService.sendData({type: ProductDataType.SelectTree, select: {type: ProductTreeType.COMPONENT,
                                                                            productGroupId: this.activeProduct.groupId,
                                                                            productId: this.productId, 
                                                                            setupid: this.activeComponent.setupid}});
          let masterSystemCounter:number = 0;
          
          for (let key in this.activeProductInstances) {
            this.activeProductInstances[key].forEach((instance:ProductInstance) => {
              if(instance.isMasterInstance){
                masterSystemCounter++;
                this.isMasterSystemSelected = this.isSupportHotfix ? masterSystemCounter == 1 : true;
              }

              let instanceAgent:Agent[] = this.solutionInfo.currentEnvironment.agents.filter((agent:Agent) => {
                return agent.macAddress == key;
              });

              if(instanceAgent.length > 0){
                instance.agent = instanceAgent[0];
              }
            
              //check if the instance were selected from the previous page
              var isSelected:boolean = false;

              if(this.selectedInstancesFromPreviousPage && this.selectedInstancesFromPreviousPage.length > 0){
                let matchedInstance:ProductInstance[] = this.selectedInstancesFromPreviousPage.filter((selectedInstance: ProductInstance) => {
                  return selectedInstance.system == instance.system && selectedInstance.installPath == instance.installPath;
                });

                isSelected = matchedInstance.length > 0;
              }else{
                isSelected = true;
              }

              let actions:ActionMenuItem[] = [new ActionMenuItem("Details", $localize`Details`, ActionMenuIcon.DETAILS, instance, false, true)];
              let row:DataTableRow = new DataTableRow({
                                                        system: instance.system,
                                                        installPath: instance.installPath,
                                                        version: instance.version,
                                                        platform: instance.platform,
                                                        instance: instance,
                                                        macAddress: instance.macAddress,
                                                        agentStatus: this.getAgentStatus(instance.agent),
                                                        metadata: instance.metadata,
                                                      },
                                                      actions,
                                                      this.isSupportHotfix && !this.isMasterSystemSelected, 
                                                      isSelected,
                                                      false, 
                                                      $localize`Change primary system to resolve the issue`);
              row.disableCheckbox = !this.isMasterSystemOnline;
              this.componentTableRows.push(row);
              if(row.selected){
                this.selectedInstanceRows.push(row);
              }
            });
          }
        }else{
          this.router.navigate(['products/overview']);
        }          
      }),
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe();
    this.dataSubscription.unsubscribe();
    this.eventMessageSubscription.unsubscribe();
  }

  selectToResync(row:DataTableRow): void {
    let index = this.selectedInstanceRows.findIndex((instanceRow:DataTableRow) => {
      return instanceRow.data.macAddress == row.data.macAddress && instanceRow.data.installPath == row.data.installPath
    });

    if(row.selected && index < 0){
      this.selectedInstanceRows.push(row);
    }else if(!row.selected && index > -1){
      this.selectedInstanceRows.splice(index, 1);
    }
    this.selectedInstancesFromPreviousPage = [];
  }

  selectAllToResync(rows:DataTableRow[]): void{
    rows.forEach((row:DataTableRow) => {
      this.selectToResync(row);
    });
    this.selectedInstancesFromPreviousPage = [];
  }

  resync():void {
    const sub: Subscription =
      this.modal.open(ModalMessageComponent, {
        data: {
          title: $localize`Resynchronization confirmation`,
          message: $localize`The selected ${this.selectedInstanceRows.length} instance(s) will be resynchronized. Resynchronize selected instances?`,
          primaryBtn: $localize`Resynchronize`,
          secondaryBtn: $localize`Cancel`,
          width: '350px'
        },
        id: 'otsc-products-resync-confirm-msg'
      }
      ).afterClosed.subscribe((isPrimaryBtnClicked: boolean) => {
        if (isPrimaryBtnClicked) {
          this.state = ResyncState.IN_PROGRESS;
          this.resyncRequestMap = new Object();

          if (this.selectedInstanceRows.length > 0) {
            this.selectedInstanceRows.forEach((row: DataTableRow) => {
              row.disableCheckbox = true;

              let instance: any = new Object();
              instance.installationDirectory = row.data.instance.installPath;
              instance.status = new TaskStatus();
              instance.status.setAsRunning();

              if (this.resyncRequestMap[row.data.macAddress]) {
                this.resyncRequestMap[row.data.macAddress].instances.push(instance);
              } else {
                let resyncRequest: any = new Object();
                resyncRequest.status = new TaskStatus();
                resyncRequest.status.setAsRunning();
                resyncRequest.system = row.data.system;
                resyncRequest.macAddress = row.data.macAddress;
                resyncRequest.version = row.data.version;
                resyncRequest.platform = row.data.platform;
                resyncRequest.instances = [];
                resyncRequest.instances.push(instance);
                this.resyncRequestMap[row.data.macAddress] = resyncRequest;
              }
            });

            for (let resyncRequest of Object.values(this.resyncRequestMap)) {
              setTimeout(() => { 
                this.siService.sendResync(this.wsService.getClientId(), this.wsService.getWSEnvId(), this.addTransaction(),
                resyncRequest).pipe(
                  tap(resp => {
                  }),
                  catchError(resp => {
                    this.state = undefined;
                    Utils.addTaskErrorHeaderMessageEventBanner(this.eventService, "PRODUCT_RESYNC", undefined);
                    return of(resp);
                  })).subscribe();
              }, 1000);
            }
          }
        }
        sub.unsubscribe();
      });
  }
  
  isResyncComplete():boolean {
    let isCompleted:boolean = true;

    for (let resyncRequest of Object.values(this.resyncRequestMap)) {
      if(!resyncRequest.status.completed){
        isCompleted = false;
        break;
      }
    }

    return isCompleted;
  }

  getNumSuccessCompletedResyncInstances():number {
    let numCompleted:number = 0;

    for (let resyncRequest of Object.values(this.resyncRequestMap)) {
      resyncRequest.instances.forEach((instance:any) => {
        if(instance.status.completed && instance.status.success){
          numCompleted++;
        }
      });
    }

    return numCompleted;
  }

  getNumResyncInstances():number {
    let instance:number = 0;

    for (let resyncRequest of Object.values(this.resyncRequestMap)) {
      if(resyncRequest.instances){
        instance = instance + resyncRequest.instances.length;
      }
    }

    return instance;
  }

  actionMenuClicked(event: ActionMenuEvent): void {
    if(event.name === "Details"){
      this.openDetails(event.data[0]);
    }
  }

  cancel():void {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  viewError():void {
    let rows:DataTableRow[] = [];

    for (let resyncRequest of Object.values(this.resyncRequestMap)) {
      resyncRequest.instances.forEach((instance:any) => {
        if(instance.status.completed && !instance.status.success){
          let msg:string;

          if(instance.status.errorCode == 'UPDATE_MISMATCH_ERROR'){
            msg = $localize`The specified product update level did not match the product analysis results.  Please check the logs for more details.`;
          }else if(instance.status.errorCode == 'RESYNCHRONIZE_FAILED'){
            msg = $localize`An error occurred while Resynchronizing instances. Please try again.`;
          }
          
          rows.push(new DataTableRow({
            system: resyncRequest.system,
            installPath: instance.installationDirectory,
            message: msg}, []));
        }
      });
    }

    this.modal.open(ProductResyncComponent, {
      data: {rows: rows, title: $localize`Resynchronization errors`, message: $localize`The following instances failed to resynchronize.`, id: "otsc-product-resync-error-dlg"},
      id: 'otsc-products-resync-error-dialog'
    })
  }

  getAgentStatus(agent:Agent): any {
    let agentStatus:any;

    if(agent == undefined){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    //disabled
    }else if(!agent.isActive){
      agentStatus = {className: 'otsc-icon-status-closed', altText: $localize`Agent is disabled`};
    //idle
    }else if(agent.isActive && agent.isOnline && !agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-away', altText: $localize`Agent is idle`};
    //busy
    }else if(agent.isActive && agent.isOnline && agent.isBusy){
      agentStatus = {className: 'otsc-icon-status-busy', altText: $localize`Agent is busy`};
    //offline
    }else if(agent.isActive && !agent.isOnline){
      agentStatus = {className: 'otsc-icon-status-cancelled', altText: $localize`Agent is offline`};
    }

    return agentStatus;
  }

  back():void {
    this.router.navigate(['../'], {relativeTo: this.route});
  }

  private openDetails(data: any): void {
    this.modal.open(InstanceDetailsComponent, {
      data: {
        instanceMetaData: JSON.parse(data.instance ? data.instance.metadata : data.metadata),
        productName: this.activeProduct.name + ' ' + this.activeProduct.version,
        supportHotfix: this.isSupportHotfix,
        id: 'otsc-products-ua-details-dialog'
      }
    });
  }

  rowClick(event: any): void {
    this.openDetails(event.data);
  }

  isError(): boolean {
    return (this.isSupportHotfix && this.isMasterSystemOnline && this.isQuickAnalysisRequired) || 
    (this.isSupportHotfix && this.isMasterSystemOnline && !this.isQuickAnalysisRequired && !this.isMasterSystemSelected)
      || (!this.isMasterSystemOnline);
  }

  analyzeMasterSystemClicked(): void {
    this.getEnableProductCapabilities(this.solutionInfo, this.activityCapabilities, this.activeProduct);
  }
}
